import { RouterProvider as TanstackRouterProvider, createRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useWarpMerchant } from 'common/hooks/useWarpMerchant';
import { COUNTRY_CODES_LOCAL_STORAGE_KEY } from 'common/state/countryState';
import { queryStringUtils, stringifySearch } from 'common/utils/queryStringUtils';

import { getTenantConfig } from '../../../config/tenantConfig';
import { ROUTE_TREE } from '../routeTree';

// Ensure the basepath always starts and ends with a slash
const normalizeBasepath = (basepath: string) => {
  const normalized = basepath.replace(/^\/+|\/+$/g, '');
  return normalized ? `/${normalized}/` : '/';
};

export const appRouter = createRouter({
  routeTree: ROUTE_TREE,
  parseSearch: queryStringUtils,
  stringifySearch,
  scrollRestoration: true,
  basepath: normalizeBasepath(__ROUTER_BASE_URL__ || '/'),
});

export function RouterProvider() {
  const { merchant } = useWarpMerchant();

  useEffect(() => {
    // TODO: find a better place for this configuration
    if (merchant) {
      const configCountryCodes = getTenantConfig(merchant.id).countryCodes;
      if (configCountryCodes) {
        localStorage.setItem(COUNTRY_CODES_LOCAL_STORAGE_KEY, JSON.stringify(configCountryCodes));
      }
    }
  }, [merchant]);

  return <TanstackRouterProvider router={appRouter} />;
}

declare module '@tanstack/react-router' {
  //eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof appRouter;
  }
}
